import { Component, OnInit, Inject, ViewChild, ElementRef, AfterViewInit, Renderer2 } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { UntypedFormControl } from '@angular/forms';
import { TooltipPosition } from '@angular/material/tooltip';

export class ExportCsvDialogOptions {
    public fieldDelimiter: string = ','; // By default will be a comma.
    public wrapFieldsInDoubleQuotes: boolean = true;
}

@Component({
    selector: 'app-export-csv',
    templateUrl: './export-csv.dialog.html',
    styleUrls: ['./export-csv.dialog.scss'],
    standalone: false
})
export class ExportCsvDialog implements OnInit {
    // Properties.
    private wrapFieldsInDoubleQuotesFormControl: UntypedFormControl;

    // Constructor.
    public constructor(public dialogRef: MatDialogRef<ExportCsvDialog>,
        @Inject(MAT_DIALOG_DATA) public initData: ExportCsvDialogOptions) {
    }

    // Life cycle methods.
    public ngOnInit(): void {
        // Initialize options.
        this.initData.wrapFieldsInDoubleQuotes = false;

        let controlProperties = {
            value: this.initData.wrapFieldsInDoubleQuotes,
            disabled: false
        };

        // Create the form control.
        this.wrapFieldsInDoubleQuotesFormControl = new UntypedFormControl(controlProperties);
        this.wrapFieldsInDoubleQuotesFormControl.valueChanges.subscribe(value => {
            this.initData.wrapFieldsInDoubleQuotes = value;
        });
    }

    // Methods called by my HTML code.
    public get Title(): string {
        return 'Export As CSV File';
    }

    public get WrapFieldsInDoubleQuotesFormControl(): UntypedFormControl {
        return this.wrapFieldsInDoubleQuotesFormControl;
    }

    public get TooltipPosition(): TooltipPosition {
        let position: TooltipPosition = 'right';

        return (position);
    }
    public get WrapFieldsInDoubleQuotesTooltip(): string {
        return 'Hint:  check this option if your fields contain any commas';
    }

    // Handle control events.
    public exportClicked(): void {
        this.dialogRef.close(this.initData);
    }
}
